import { isSocialCasino } from './casino';

interface CurrencySymbolMap {
    [key: string]: string;
}

// Rate between USD and FUN currency
export const FUN_CURRENCY_RATE = 0.001;
export const SOCIAL_CURRENCY_RATE = 0.001;

export const FUN_CURRENCY_CODE = 'GC';
export const SOCIAL_CURRENCY_CODE = 'SC';

const $html = document.querySelector('html');

const currencySymbolMap: CurrencySymbolMap = {
    ZMW: 'K',
    USD: '$',
    XAF: 'FCFA',
    XOF: 'FCFA',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    PLN: 'zł',
    BDT: '৳',
};

export function getCurrencySymbol(code: string): string {
    if (isSocialCasino()) {
        return FUN_CURRENCY_CODE;
    }

    return currencySymbolMap[code] || code;
}

export function systemCurrency(): string {
    const currency = $html.dataset.currency;

    if (!currency) {
        throw new Error('System currency is not set as HTML data-currency attribute!');
    }

    return currency;
}

export function getUserCurrency(): string {
    const userCurrency = $html.dataset.userCurrency;

    if (!userCurrency) {
        throw new Error('User currency is not set as HTML data-user-currency attribute!');
    }

    return userCurrency;
}
